var React = require('react');

function ArrowPrev (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.1806 0.925207C17.589 1.3299 17.8184 1.87871 17.8184 2.45094C17.8184 3.02318 17.589 3.57199 17.1806 3.97668L5.6517 15.3992L17.1806 26.8217C17.5774 27.2288 17.7969 27.7739 17.792 28.3397C17.787 28.9055 17.5579 29.4468 17.1541 29.8469C16.7502 30.247 16.2039 30.474 15.6328 30.4789C15.0617 30.4838 14.5115 30.2663 14.1007 29.8732L1.03185 16.9249C0.62351 16.5203 0.394119 15.9714 0.394119 15.3992C0.394119 14.827 0.62351 14.2782 1.03185 13.8735L14.1007 0.925207C14.5092 0.520635 15.0631 0.293361 15.6407 0.293361C16.2182 0.293362 16.7722 0.520636 17.1806 0.925207Z","fill":"#3B79D6"}));
}

ArrowPrev.defaultProps = {"width":"18","height":"31","viewBox":"0 0 18 31","fill":"none"};

module.exports = ArrowPrev;

ArrowPrev.default = ArrowPrev;
